import React, { forwardRef } from 'react';
import clsx from '@strava/ui/clsx';
import styles from './Input.module.scss';

type InputProps = React.ComponentPropsWithoutRef<'input'>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => (
    <input
      type="text"
      className={clsx(styles.input, className)}
      ref={ref}
      {...props}
    />
  )
);

export default Input;
